module.exports = __webpack_public_path__ + "img/healthPro4.8117dcee.png";